import React from 'react';
import { useDroppable } from '@dnd-kit/core';

/**
 * BottomDropZone component
 * Provides a drop target at the bottom of a column
 */
export default function BottomDropZone({ id }) {
    const { setNodeRef, isOver } = useDroppable({
        id: id
    });

    const zoneClasses = isOver
        ? 'h-16 rounded-lg border-2 border-dashed border-pink-400 bg-pink-50/50 dark:bg-pink-950/20 transition-all'
        : 'h-16 rounded-lg border-2 border-dashed border-transparent hover:border-pink-300 hover:bg-pink-50/30 dark:hover:bg-pink-950/10 transition-all';

    return (
        <div ref={setNodeRef} className={zoneClasses} />
    );
}
